import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic';
import Link from 'next/link'
import Navbar from "../../components/Layouts/Navbar";
import Footer from "../../components/Layouts/Footer";
import HeroBanner from '../../components/Common/HeroBanner';
import DButton from '../../components/elements/DButton';
import Breadcrumb from '../../components/Layouts/Breadcrumb';
import Image from 'next/image';
import { caseStudyNewsLetterList } from '../../components/Common/DataSet/NewsLetterData';
import SectionHeading from '../../components/Common/SectionHeading';
const NewsLetterSection = dynamic(() => import('../../components/Common/NewsLetterSection', { ssr: false }))
import ExitIntent from '../../components/Common/ExitIntentForm'
import { useGetRandomCaseStudiesQuery } from '../../components/Store/Features/CaseStudiesAPI'
import CommonPopup from '../../components/PopupForm/CommonPopup';
import * as Yup from 'yup';
import BorderBtn from '../../components/Common/BorderBtn';
import axios from 'axios'
import { HTMLParser } from '../../components/Common/Functions';



export const ourRelatedServices = [
    {
        id: 1,
        title: "Asset Prioritization",
        link: "/consulting/asset-prioritizaton-services",
        shortDescription: "Develop R&D strategy with reliable analysis of your asset group and come up focused list of prioritized assets.",
    },
    {
        id: 2,
        title: "Business Development",
        link: "/consulting/business-development-services",
        shortDescription: "Converting Strategic Plans into Intelligent Business Decisions",
    },
    {
        id: 3,
        title: "Competitive Intelligence Services",
        link: "/consulting/competitive-intelligence-services",
        shortDescription: "Real-Time, Actionable and Strategic Insights",
    },
    {
        id: 4,
        title: "Licensing Services",
        link: "/consulting/licensing-services",
        shortDescription: "Providing scientific innovation a boost towards clinical development and commercial milestone achievement",
    },
    {
        id: 5,
        title: "Mergers and Acquisition",
        link: "/consulting/merger-and-acquisition",
        shortDescription: "Managing post-merger positioning of competencies and capabilities to extract best possible capabilities of the merged entities",
    },
    {
        id: 6,
        title: "Partner Identification",
        link: "/consulting/partner-identification-services",
        shortDescription: "Service that helps identify, acquire, measure and manage collaborations",
    },
    {
        id: 7,
        title: "Competitive Benchmarking",
        link: "/consulting/competitive-benchmarking-services",
        shortDescription: "Measure your brand among others in the competitive arena you occupy.",
    },
    {
        id: 8,
        title: "Portfolio Management",
        link: "/consulting/pharmaceutical-portfolio-management-solutions",
        shortDescription: "Matching Competencies and vision to develop a strong portfolio for future gains",
    },
    {
        id: 9,
        title: "R&D Analysis",
        link: "/consulting/r-and-d-analysis",
        shortDescription: "Understanding the realm of Pharmaceuticals to create value based decisions and help clients achieve better outcomes in their R&D endeavors",
    },
    {
        id: 10,
        title: "Pipeline Assessment",
        link: "/consulting/pipeline-assessment-services",
        shortDescription: "Have Actionable Intelligence to support the development of your candidate through its clinical development journey",
    },
    {
        id: 11,
        title: "Market Assessment",
        link: "/consulting/market-assessment-services",
        shortDescription: "Achieve Breakthroughs with all-encompassing Market Outlook Research",
    },
    {
        id: 12,
        title: "Regulatory Analysis",
        link: "/consulting/regulatory-analysis-services",
        shortDescription: "DUnderstand regulatory framework of different regulatory bodies across the globe, and simplify approval process",
    },
    {
        id: 13,
        title: "Due Diligence",
        link: "/consulting/due-diligence-services",
        shortDescription: "A comprehensive appraisal of assets and liabilities undertaken by DelveInsight to provide a bright outlook of an asset or a business or an entity.",
    },
    {
        id: 14,
        title: "Primary Research",
        link: "/consulting/primary-research-services",
        shortDescription: "Expertly crafted primary research techniques provide in-depth corporate intelligence and competitive analysis based on real-time primary research. DelveInsight offers timely and practical insights on strategic news updates to senior leadership, aiding and improving pharmaceutical competitive intelligence.",
    },
    {
        id: 15,
        title: "Conference Coverage",
        link: "/consulting/conference-coverage-services",
        shortDescription: "Tracking Key Conferences to provide intelligent insights",
    },
    {
        id: 16,
        title: "CI Tracking",
        link: "/consulting/ci-tracking",
        shortDescription: "DelveInsight’s systematic gathering and information analysis around activities, strategies, and capabilities of competitors in the healthcare industry keeps organizations up-to-date with industry trends. Healthcare competitive Intelligence tracking services help our client partners make informed decisions about their own strategies and operations. To stay ahead in a competitive and dynamic Pharma/Biotech Industry, our continuous coverage and periodic updates aid in bridging the gap between success and outstanding success.",
    },
];

const CaseStudyProfile = ({data, isMobile}) => {
    const router = useRouter();
    const { slug } = router.query;
    useEffect(() => {
        caseStudyNewsLetterList.click=openModalRFP;
        
    }, [])
    const [DataRendered, setDataRendered] = useState(false);
    useEffect(() => {
        setDataRendered(true)
    }, [])

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenRFP, setIsModalOpenRFP] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };
    const openModalRFP = () => {
        setIsModalOpenRFP(true);
    };
    const closeModalRFP = () => {
        setIsModalOpenRFP(false);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const options = {
        btn_name: "Submit"
    }

    const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/

    const fields = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'

        },
        {
            name: 'company_name',
            label: '',
            placeholder: 'Company Name',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'phone',
            label: '',
            placeholder: 'Phone Number',
            validation: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
            customClass: 'md:col-span-6 col-span-12'
        }
    ];

    
    const { data: randomCaseStudies, isSuccess, refetch } = useGetRandomCaseStudiesQuery('/case-studies/random-case-studies');
    const [caseStudies, setCaseStudies] = useState([])
    const [CaseStudyDetails, setCaseStudyDetails] = useState("");

    useEffect(() => {
        // console.log(data)
        if(data != null){
            setCaseStudies(data)
            setTrigger(true)
        }else{
            router.push('/404')
        }
    }, [data])

    const [trigger, setTrigger] = useState(false);

    useEffect(() => {
        if (caseStudies?.description) {
            HTMLParser(caseStudies?.description, setCaseStudyDetails)
        }
    }, [trigger]);

    useEffect(() => {
        refetch()
        if (caseStudies?.description) {
            HTMLParser(caseStudies?.description, setCaseStudyDetails)
        }
    }, [slug,trigger,caseStudies])

    const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)
    useEffect(() => {
        const onScroll = () => setScrolled(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    useEffect(() => {
        if (scrolled > 20) {
            setScrolledStatus(true)
        }
    }, [scrolled])



    const [randomServices, setRandomServices] = useState([]);

    useEffect(() => {
        const shuffledList = ourRelatedServices.slice(); // Create a copy of the list.
        let currentIndex = shuffledList.length;
        let temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            temporaryValue = shuffledList[currentIndex];
            shuffledList[currentIndex] = shuffledList[randomIndex];
            shuffledList[randomIndex] = temporaryValue;
        }

        // Get the first two elements from the shuffled list.
        const selectedTitles = shuffledList.slice(0, 2);
        setRandomServices(selectedTitles);
    }, []);
    return (
        <>
            <Navbar />
            {scrolledStatus &&
                <ExitIntent 
                    product_name={caseStudies?.title} 
                    title="Download Case Study to Unlock Valuable Insights"
                    shortDescription="Fill out the form to gain access to exclusive content and data-driven strategies"
                    page_name="Exit Intent Case Study"
                    form_name="exit-intent-case-study"
                />
            }
            <HeroBanner
                background={process.env.IMG_CDN + "img/banner/case-study-profile.webp"}
                title={<>{caseStudies?.title}</>}
                description={<>{caseStudies?.tag_line_on_Banner}</>}
                buttonOnBanner={<>
                    <div className="flex grid-cols-1 sm:grid-cols-4">
                        <DButton title="Download Detailed Case Study" customClass='' onclick={openModal} />
                        <CommonPopup 
                            isOpen={isModalOpen} 
                            closeModal={closeModal}
                            fields={fields}
                            options={options}
                            page_name={caseStudies?.title + " " + 'Popup Form'}
                            form_name="exclusive-success-story"
                            product_name={caseStudies?.title}
                            formTitle="Fill in your details and discover our exclusive success story"
                            endpoint="/enquiry/download-visuals"
                        />
                    </div>
                </>}
            />
            <Breadcrumb />
            <section className="flex flex-col justify-center w-11/12 mx-auto xl:max-w-screen max-w-screen-2xl">
                <div className='my-4 lg:my-8'>
                    <div className='grid grid-cols-12 gap-4'>
                        <div className='col-span-12 xl:col-span-9 lg:col-span-8'>
                            <div className='caseStudyDetails' dangerouslySetInnerHTML={{ __html: CaseStudyDetails }}></div>
                        </div>
                        { (scrolledStatus) &&
                            <div className='col-span-12 xl:col-span-3 lg:col-span-4'>
                                <div className="w-full p-4 my-4 bg-white rounded shadow-md dark:bg-gray-700 lg:mb-4">
                                    <h3 className='text-lg font-semibold text-blue-500'>
                                        <i className="pb-4 pr-4 text-blue-500 fas fa-file-lines"></i>
                                        Our Related Services
                                    </h3>
                                    <div className="w-full border border-blue-900 opacity-60"></div>
                                    <div className="pr-2 overflow-y-auto max-h-52 ">
                                        {randomServices.map((item, index) => (
                                            <div key={index} className="flex p-4 my-2 bg-gray-100 rounded dark:bg-gray-600 hover:bg-blue-200">
                                                <Link href={process.env.APP_URL + item?.link}>
                                                    <div className="w-full">
                                                        <h4 className="font-semibold text-blue-500 text-md">{item?.title}</h4>
                                                        <p className="my-2 overflow-hidden line-clamp-2">{item?.shortDescription}</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="w-full p-4 bg-white rounded shadow-md dark:bg-gray-700 lg:mt-8">
                                    <h3 className='text-lg font-semibold text-blue-500'>
                                        <i className="pb-4 pr-4 text-blue-500 fas fa-image"></i>
                                        Sample Visuals
                                    </h3>
                                    <div className="w-full border border-blue-900 opacity-60"></div>
                                    <div className="pr-2 my-2 overflow-y-auto max-h-48 ">
                                        {
                                            caseStudies?.visuals?.map((data, index) => {
                                                return (
                                                    <div key={index} className="group relative my-4 before:content-[''] hover:before:absolute hover:before:left-0 before:top-0 before:w-full before:h-full before:bg-[#00000082] before:opacity-0.1  before:transition-all before:duration-300 before:ease-in-out before:visible">
                                                        <Image priority={false} className="w-full rounded-lg" width={2000} height={2000} alt="Delveinsight Case Study Visual" src={process.env.IMG_CDN + data.image} title="Delveinsight Case Study Visual" />
                                                        <div className="absolute top-0 left-0 flex flex-col items-center justify-between invisible w-full transition-all duration-300 ease-in-out opacity-0 projectContent group-hover:opacity-100 group-hover:visible group-hover:bottom-0">
                                                            <div className="w-full projectPara">
                                                                <h3 className="w-full p-2 m-0 text-base text-center text-white bg-blue-600 rounded-t">Get Visuals</h3>
                                                            </div>
                                                            <div className="absolute block mx-auto mt-20 projectBtn top-4" onClick={openModal}>
                                                                <BorderBtn
                                                                    buttonTitle="Download"
                                                                    customFields={fields}
                                                                    page_name="Case Study Profile"
                                                                    form_name="sample-visuals-popup"
                                                                    formTitle="Fill the form to get the visuals"
                                                                    endpoint="/enquiry/download-visuals"
                                                                    customClass="p-3 w-auto mx-auto bg-white dark:bg-gray-700 dark:text-white text-blue-800 rounded-lg font-semibold text-base capitalize"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </section>
            {(scrolledStatus) &&
                <>
                    <NewsLetterSection 
                        data={caseStudyNewsLetterList} 
                        customClass="text-white bg-[#1b5df3] border-0 rounded-none p-2"
                        customFields={fields}
                        page_name="Case Study Profile"
                        form_name="exclusive-success-story"
                        formTitle="Fill in your details and discover our exclusive success story"
                        product_name={caseStudies?.title}
                        endpoint="/enquiry/download-visuals"
                        slug={slug}
                    />

                    <section className='flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10'>
                        <SectionHeading
                            title="Related Insights"
                        />
                        <div className='grid grid-cols-12 gap-4'>
                            {
                                randomCaseStudies?.map((data, index) => {
                                    return (
                                        <div className='col-span-12 lg:col-span-4' key={index}>
                                            <div className="mb-4 border-t-4 border-blue-500 rounded-t-lg">
                                                <div className="rounded-t bg-[#f3f5f6] p-4">
                                                    <Link href={process.env.APP_URL+"/case-study/" + data.slug} className="py-4 text-blue-500">
                                                        <h3 className="text-lg font-semibold text-center text-black line-clamp-1">{data?.title}</h3>
                                                    </Link>
                                                </div>
                                                <Link href={process.env.APP_URL+"/case-study/" + data.slug} className="py-4 text-blue-500">
                                                    <Image priority={false} width={2000} height={2000} src={process.env.IMG_CDN + data.image} alt={data.image_alt} className="w-full h-60" />
                                                </Link>
                                                <p className="text-base line-clamp-3">{data.short_description}</p>
                                                <Link href={process.env.APP_URL+"/case-study/" + data.slug} className="py-4 text-blue-500">View Case Study <i className="fa fa-arrow-right"></i></Link>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </section>

                    <Footer />
                </>
            }
        </>
    );
};


export async function getServerSideProps({ req, res, resolvedUrl }) {
    const UA = req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ))
    let redirecting = {
        redirect: {
            permanent: false,
            destination: "/404"
        }
    }

    let slug = resolvedUrl;
    try {
        let cleanedSlug = slug.replace(/\/$/, '');
        // console.log(cleanedSlug);
        cleanedSlug = cleanedSlug.replace(/\/case-study\//, '');
        let apiUrl = process.env.API_URL + '/case-studies/' + cleanedSlug;
        // console.log(apiUrl);
        const output = await fetch(apiUrl, { method: 'GET', headers: { 'Content-Type': 'application/json', } });
        const response = await output.json();
        // console.log(response);
        if (response) {
            return {
                props: {
                    title: (response?.meta.meta_title) ? response?.meta.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
                    description: (response?.meta.meta_description) ? response?.meta.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
                    keywords: (response?.meta.meta_keywords) ? response?.meta.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
                    data: response ? response : [],
                    isMobile: isMobile
                }
            }
        } else{
            return redirecting;
        }
    } catch (error) {
        console.log(error)
        return redirecting;
    }
}


export default CaseStudyProfile;
